export default __webpack_public_path__ + "static/media/AnimalsYellow_01.ee5f0fe7.png";